// flow weak

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AnimatedView from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import AddCompetitionExpenses from '../addCompetitionExpense';
import FlatButton from 'material-ui/FlatButton';
var Spinner = require('react-spinkit');
import Modal from 'react-modal';
import AddRegistration from '../addTournamentRegistration';
import { isMobile } from 'react-device-detect';
import { colors, btn, btnGroup, card, table, form, modal, summary, empty, spinner, search, chipWrap } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg = type === 'error' ? colors.dangerLt : colors.successLt;
  const color = type === 'error' ? colors.danger : colors.success;
  const border = type === 'error' ? '#fca5a5' : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class ViewCompetitionRegistration extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id: props.competition_id,
      registration_details: [],
      data_uploaded: false,
      data_error: false,
      is_loading: true,
      registration_fields: [],
      tournament_id: '',
      mobile_no: null,
      customer_search_list: [],
      team_members: [],
      player_id: '',
      search: false,
      add_user_modal: false,
      registrationModel: false,
      amount: 0,
      payment_modes: [],
      payment_mode: '',
      transaction_id: '',
      payment_screenshot: null,
      // toast state
      toast: null,         // { message, type: 'error' | 'success' }
      modal_toast: null,   // toast scoped inside modals
      search_loading: false,
    };
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.chipStyle = { margin: 4 };
  }

  componentDidMount() {
    this.getExpenseDetail();
    this.getPaymentModes();
  }

  showToast(message, type = 'error') {
    this.setState({ toast: { message, type } });
  }

  showModalToast(message, type = 'error') {
    this.setState({ modal_toast: { message, type } });
  }

  getExpenseDetail() {
    const url = `${getLocationOrigin()}/tournament/get_competition_registrations/`;
    const options = { ...defaultOptions };
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ competition_id: this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        const registration_fields = data.registration_fields.filter(i => i !== 'category');
        const additional_details = {};
        registration_fields.forEach(item => { additional_details[item] = null; });
        this.setState({
          registration_details: data.registration_details,
          registration_fields,
          additional_details,
          tournament_id: data.tournament_id,
          is_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ is_loading: false });
        this.showToast(error && error.message ? error.message : 'Failed to load registrations');
      });
  }

  getPaymentModes() {
    const url = `${getLocationOrigin()}/eagleeye/get_payment_modes/`;
    const options = { ...defaultOptions };
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        const modes = data.payment_modes || {};
        const modesList = Object.keys(modes).map(key => ({ value: key, label: modes[key] }));
        this.setState({ payment_modes: modesList });
      })
      .catch(error => {
        console.log('Failed to fetch payment modes', error);
      });
  }

  handleFileChange(event) {
    this.setState({ payment_screenshot: event.target.files[0] });
  }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data.id)} style={this.chipStyle}>
        <Avatar id={data.id} src={data.photo === 'http://www.sporthood.in/assets/img/avatar.png' ? data.photo : `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  handleRequestDelete = key => {
    const team_members = [...this.state.team_members];
    team_members.splice(team_members.findIndex(c => c.id === key), 1);
    this.setState({ team_members });
  };

  onClickDownload() {
    window.open(`${getLocationOrigin()}/tournament/download_competition_registrations/?competition_id=${this.state.competition_id}`);
  }

  onClickAddRegistrations() { this.setState({ registrationModel: true, modal_toast: null }); }

  searchCustomer() {
    const term = this.state.mobile_no;
    if (!term || String(term).trim() === '') {
      this.showModalToast('Search cannot be blank');
      return;
    }
    if (String(term).trim().length < 3) {
      this.showModalToast('Enter at least 3 characters to search');
      return;
    }
    this.getSearchList(term);
  }

  getSearchList(mobile_no) {
    this.setState({ search_loading: true, modal_toast: null });
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = { ...defaultOptions };
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ search: mobile_no, competition_id: this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        // Backend returns {"Message": "..."} with status 200 for validation errors
        // (e.g. search term too short). Check for this before reading results.
        if (data.Message) {
          this.setState({ customer_search_list: [], search: false, search_loading: false });
          this.showModalToast(data.Message);
          return;
        }
        this.setState({
          customer_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ customer_search_list: [], search: false, search_loading: false });
        this.showModalToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  setSearch(name, mobile, id) {
    this.setState({
      player_id: id,
      search: false,
      team_members: [{ id, name, photo: 'http://www.sporthood.in/assets/img/avatar.png' }],
      customer_search_list: [],
      modal_toast: null,
    });
  }

  changeAdditionalDetails(e) {
    this.setState({ additional_details: { ...this.state.additional_details, [e.target.name]: e.target.value } });
  }

  cancelRegistration() {
    const registration_fields = this.state.registration_fields.filter(i => i !== 'category');
    const additional_details = {};
    registration_fields.forEach(item => { additional_details[item] = null; });
    this.setState({ registrationModel: false, mobile_no: null, name: null, additional_details, team_members: [], modal_toast: null, search: false, customer_search_list: [], payment_mode: '', transaction_id: '', payment_screenshot: null });
    if (this.fileInputRef) this.fileInputRef.value = '';
  }

  addRegistration() {
    if (!this.state.team_members.length) {
      this.showModalToast('Please select a customer');
      return;
    }
    const customer_id = this.state.team_members[0].id;
    if (Number(this.state.amount) > 0 && !this.state.payment_mode) {
      this.showModalToast('Please select a payment mode');
      return;
    }
    if (Number(this.state.amount) > 0 && !this.state.transaction_id && !this.state.payment_screenshot) {
      this.showModalToast('Please provide either Transaction ID or Payment Screenshot');
      return;
    }
    if (customer_id && this.state.competition_id && this.state.tournament_id) {
      const url = `${getLocationOrigin()}/tournament/add_tournament_registration/`;
      const formData = new FormData();
      formData.append('tournament_id', this.state.tournament_id);
      formData.append('competition_id', this.state.competition_id);
      formData.append('customer_id', customer_id);
      formData.append('amount', this.state.amount);
      if (this.state.additional_details) {
        formData.append('additional_details', JSON.stringify(this.state.additional_details));
      }
      if (this.state.payment_mode) {
        formData.append('payment_mode', this.state.payment_mode);
      }
      if (this.state.transaction_id) {
        formData.append('transaction_id', this.state.transaction_id);
      }
      if (this.state.payment_screenshot) {
        formData.append('payment_screenshot', this.state.payment_screenshot);
      }
      const options = { ...defaultOptions };
      options['method'] = 'post';
      options['headers'] = {};
      options['body'] = formData;
      return fetch(url, options).then(checkStatus).then(parseJSON)
        .then(response => {
          this.showToast(response.message, 'success');
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
          this.showModalToast(error && error.message ? error.message : 'Failed to add registration');
        });
    } else {
      this.showModalToast('Please fill required fields');
    }
  }

  submitCustomer() {
    if (!this.state.name) { this.showModalToast('Enter name'); return; }
    if (!this.state.mobile_no || String(this.state.mobile_no).length !== 10) {
      this.showModalToast('Enter a valid 10-digit mobile number');
      return;
    }
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer_tournament/`;
    const options = { ...defaultOptions };
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ customer_name: this.state.name, customer_mobile: this.state.mobile_no, tournament_id: this.state.tournament_id });
    return fetch(url, options).then(checkStatus).then(parseJSON)
      .catch(error => {
        console.log(error);
        this.showModalToast(error && error.message ? error.message : 'Failed to add user');
      })
      .then(data => {
        if (!data) return;
        if (data.success) {
          this.setState({
            team_members: [{ id: data.customer.id, name: data.customer.name, photo: 'http://www.sporthood.in/assets/img/avatar.png' }],
            add_user_modal: false,
            registrationModel: true,
            modal_toast: { message: data.message, type: 'success' },
          });
        } else {
          this.showModalToast(data.message || 'Something went wrong');
        }
      });
  }

  renderRegistrations() {
    const { registrationModel, search: showSearch, customer_search_list, team_members, registration_fields, search_loading, modal_toast } = this.state;
    return (
      <Modal isOpen={registrationModel} onRequestClose={() => this.cancelRegistration()} style={modal.reactModal}>
        <div style={modal.content}>
          <h3 style={modal.title}>Add Registration</h3>

          <Toast
            message={modal_toast && modal_toast.message}
            type={modal_toast && modal_toast.type}
            onClose={() => this.setState({ modal_toast: null })}
          />

          <div style={form.row}>
            <div style={form.label}>Customer Search</div>
            <div style={form.searchWrap}>
              <input
                type="text"
                placeholder="Search by name / mobile (min 3 chars)…"
                style={form.searchInput}
                value={this.state.mobile_no || ''}
                onChange={e => this.setState({ mobile_no: e.target.value, modal_toast: null })}
                onKeyDown={e => e.key === 'Enter' && this.searchCustomer()}
              />
              <button
                style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                onClick={() => this.searchCustomer()}
                disabled={search_loading}
              >
                {search_loading ? '…' : '🔍'}
              </button>
            </div>
          </div>

          {showSearch && (
            <div style={search.results}>
              {customer_search_list.length ? customer_search_list.map(x => (
                <div
                  key={x.id}
                  style={{ ...search.item, ...(x.customer_type === 2 ? search.itemChild : search.itemMember) }}
                  onClick={() => this.setSearch(x.name, x.mobile_no, x.id)}
                >
                  <span style={search.name}>{x.name} · {x.mobile_no}</span>
                  <span style={search.meta}>
                    {x.payment_status.status}
                    {x.payment_status.venue ? ` · ${x.payment_status.venue}` : ''}
                    {x.payment_status.age_group ? ` · ${x.payment_status.age_group}` : ''}
                    {x.customer_type === 2 ? ' · Child' : ''}
                  </span>
                </div>
              )) : (
                <div style={search.notFound}>
                  <span style={search.notFoundText}>Customer not found</span>
                </div>
              )}
            </div>
          )}

          <div style={form.row}>
            <div style={form.label}>Selected Player</div>
            <div style={chipWrap}>{team_members.map(this.renderChip, this)}</div>
          </div>

          {registration_fields.length > 0 && registration_fields.map(field => (
            <div style={form.row} key={field}>
              <div style={form.label}>{field}</div>
              <input type="text" name={field} style={form.input} value={this.state.additional_details[field] || ''} onChange={e => this.changeAdditionalDetails(e)} />
            </div>
          ))}

          <div style={form.row}>
            <div style={form.label}>Amount Collected</div>
            <input type="number" name="amount" style={form.input} value={this.state.amount} onChange={e => this.setState({ amount: e.target.value })} />
          </div>

          {Number(this.state.amount) > 0 && (
            <div style={form.row}>
              <div style={form.label}>Payment Mode</div>
              <select name="payment_mode" style={form.select} value={this.state.payment_mode} onChange={e => this.setState({ payment_mode: e.target.value })}>
                <option value="">Select payment mode…</option>
                {this.state.payment_modes.map(mode => (
                  <option key={mode.value} value={mode.value}>{mode.label}</option>
                ))}
              </select>
            </div>
          )}

          {Number(this.state.amount) > 0 && (
            <div style={form.row}>
              <div style={form.label}>Transaction ID</div>
              <input type="text" name="transaction_id" style={form.input} placeholder="Enter transaction ID" value={this.state.transaction_id} onChange={e => this.setState({ transaction_id: e.target.value })} />
            </div>
          )}

          {Number(this.state.amount) > 0 && (
            <div style={form.row}>
              <div style={form.label}>Payment Screenshot</div>
              <div style={{ flex: 1 }}>
                {this.state.payment_screenshot ? (
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img
                      src={URL.createObjectURL(this.state.payment_screenshot)}
                      alt="Payment screenshot"
                      style={{ maxWidth: 200, maxHeight: 120, borderRadius: 6, border: `1px solid ${colors.border}`, display: 'block' }}
                    />
                    <button
                      type="button"
                      onClick={() => { this.setState({ payment_screenshot: null }); if (this.fileInputRef) this.fileInputRef.value = ''; }}
                      style={{
                        position: 'absolute', top: -6, right: -6, width: 22, height: 22, borderRadius: '50%',
                        background: colors.danger, color: '#fff', border: 'none', cursor: 'pointer',
                        fontSize: 12, lineHeight: '22px', textAlign: 'center', padding: 0,
                      }}
                    >✕</button>
                  </div>
                ) : (
                  <input type="file" accept="image/*" ref={el => { this.fileInputRef = el; }} style={{ ...form.input, paddingTop: 6 }} onChange={this.handleFileChange} />
                )}
              </div>
            </div>
          )}

          {Number(this.state.amount) > 0 && (
            <div style={{ fontSize: 12, color: colors.muted, marginTop: -8, marginBottom: 14, paddingLeft: 152 }}>* Either Transaction ID or Payment Screenshot is required</div>
          )}

          <div style={modal.footer}>
            <button style={btn.cancel} onClick={() => this.cancelRegistration()}>Cancel</button>
            <button style={btn.primary} onClick={() => this.addRegistration()}>Submit Registration</button>
          </div>
        </div>
      </Modal>
    );
  }

  renderAddUser() {
    const { modal_toast } = this.state;
    return (
      <Modal isOpen={this.state.add_user_modal} onRequestClose={() => this.setState({ add_user_modal: false, modal_toast: null })} style={modal.reactModal}>
        <div style={modal.content}>
          <h3 style={modal.title}>Add New User</h3>

          <Toast
            message={modal_toast && modal_toast.message}
            type={modal_toast && modal_toast.type}
            onClose={() => this.setState({ modal_toast: null })}
          />

          <div style={form.row}>
            <div style={form.label}>Name</div>
            <input type="text" style={form.input} value={this.state.name || ''} onChange={e => this.setState({ name: e.target.value })} />
          </div>
          <div style={form.row}>
            <div style={form.label}>Mobile No</div>
            <input type="number" style={form.input} value={this.state.mobile_no || ''} onChange={e => this.setState({ mobile_no: e.target.value })} />
          </div>
          <div style={modal.footer}>
            <button style={btn.cancel} onClick={() => this.setState({ add_user_modal: false, modal_toast: null })}>Cancel</button>
            <button style={btn.primary} onClick={() => this.submitCustomer()}>Add User</button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    const { is_loading, registration_details, toast } = this.state;

    if (is_loading) {
      return <div style={spinner.wrap}><Spinner name="line-scale-pulse-out-rapid" color={spinner.color} /></div>;
    }

    const locationlist  = registration_details.filter(x => x.location && x.location !== '');
    const emaillist     = registration_details.filter(x => x.email_id != null);
    const namelist      = registration_details.filter(x => x.name != null);
    const teamlist      = registration_details.filter(x => x.team != null);
    const additional    = registration_details.filter(x => !['{}', null, 'null', {}].includes(x.additional_details_json));
    const batch         = registration_details.filter(x => x.batch != null);
    const year_of_birth = registration_details.filter(x => x.year_of_birth != null);
    const totalCount    = registration_details.length;
    const totalAmount   = registration_details.reduce((sum, r) => sum + (parseFloat(r.payment_amount) || 0), 0);
    const avgAmount     = totalCount > 0 ? Math.round(totalAmount / totalCount) : 0;
    const labelColspan  = 3 + (year_of_birth.length > 0 ? 1 : 0) + (namelist.length > 0 ? 1 : 0) + 1 + (locationlist.length > 0 ? 1 : 0) + (emaillist.length > 0 ? 1 : 0) + (batch.length > 0 ? 2 : 0) + (teamlist.length > 0 ? 1 : 0);

    const extra_colspan = additional.length>0?3:2
    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>
        {this.renderRegistrations()}
        {this.renderAddUser()}

        {/* Page-level toast */}
        {toast && (
          <div style={{ padding: '16px 24px 0' }}>
            <Toast
              message={toast.message}
              type={toast.type}
              onClose={() => this.setState({ toast: null })}
            />
          </div>
        )}

        {totalCount > 0 && (
          <div style={{ ...summary.row, padding: '20px 24px 0' }}>
            <div style={summary.card}>
              <div style={{ ...summary.icon, ...summary.iconBlue }}>👥</div>
              <div style={summary.label}>Total Registrations</div>
              <div style={summary.value}>{totalCount}</div>
            </div>
            <div style={summary.card}>
              <div style={{ ...summary.icon, ...summary.iconGreen }}>₹</div>
              <div style={summary.label}>Total Amount Collected</div>
              <div style={{ ...summary.value, color: colors.success }}>₹{totalAmount.toLocaleString('en-IN')}</div>
            </div>
            <div style={summary.card}>
              <div style={{ ...summary.icon, ...summary.iconAmber }}>⌀</div>
              <div style={summary.label}>Avg. per Registration</div>
              <div style={summary.value}>₹{avgAmount.toLocaleString('en-IN')}</div>
            </div>
          </div>
        )}

        <div style={card.header}>
          <h2 style={card.title}>
            Registrations
            {totalCount > 0 && <span style={card.titleCount}>{totalCount} entries</span>}
          </h2>
          <div style={btnGroup}>
            <button style={btn.outline} onClick={() => this.onClickAddRegistrations()}>+ Add Registration</button>
            {totalCount > 0 && <button style={btn.primary} onClick={() => this.onClickDownload()}>↓ Download</button>}
          </div>
        </div>

        {totalCount > 0 ? (
          <div style={table.wrap}>
            <table style={table.table}>
              <thead>
                <tr>
                  <th style={table.th}>#</th>
                  <th style={table.th}>Date</th>
                  <th style={table.th}>Customer</th>
                  {year_of_birth.length > 0 && <th style={table.th}>Year of Birth</th>}
                  {namelist.length > 0        && <th style={table.th}>Name</th>}
                  <th style={table.th}>Mobile</th>
                  {locationlist.length > 0    && <th style={table.th}>Location</th>}
                  {emaillist.length > 0       && <th style={table.th}>Email</th>}
                  {batch.length > 0           && <th style={table.th}>Venue</th>}
                  {batch.length > 0           && <th style={table.th}>Batch</th>}
                  {teamlist.length > 0        && <th style={table.th}>Team</th>}
                  <th style={table.th}>Amount</th>
                  {additional.length > 0      && <th style={table.th}>Details</th>}
                  <th style={table.th}>Payment Mode</th>
                  <th style={table.th}>Transaction Id</th>
                </tr>
              </thead>
              <tbody>
                {registration_details.map((reg, index) => (
                  <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                    <td style={table.tdMuted}>{index + 1}</td>
                    <td style={table.td}>{reg.created_on}</td>
                    <td style={table.tdBold}>{reg.customer}</td>
                    {year_of_birth.length > 0 && <td style={table.td}>{reg.year_of_birth}</td>}
                    {namelist.length > 0       && <td style={table.td}>{reg.name}</td>}
                    <td style={table.td}>{reg.contact_number}</td>
                    {locationlist.length > 0   && <td style={table.td}>{reg.location}</td>}
                    {emaillist.length > 0      && <td style={table.td}>{reg.email_id}</td>}
                    {batch.length > 0          && <td style={table.td}>{reg.batch && reg.batch.venue}</td>}
                    {batch.length > 0          && <td style={table.td}>{reg.batch && reg.batch.name}</td>}
                    {teamlist.length > 0       && <td style={table.td}>{reg.team}</td>}
                    <td style={table.tdAmount}>{reg.payment_amount ? `₹${parseFloat(reg.payment_amount).toLocaleString('en-IN')}` : '—'}</td>
                    {additional.length > 0 && (
                      <td style={table.td}>{reg.additional_details_json && reg.additional_details_json !== 'null' ? reg.additional_details_json.replace(/{|}|"/gi, '') : ''}</td>
                    )}
                    <td style={table.td}>{reg.payment_mode}</td>
                    <td style={table.td}>{reg.transaction_id?reg.transaction_id:'------'}</td>
                  </tr>
                ))}
                <tr style={table.trTotal}>
                  <td colSpan={labelColspan} style={table.tdTotalLabel}>Total ({totalCount} registrations)</td>
                  <td style={table.tdTotalAmount}>₹{totalAmount.toLocaleString('en-IN')}</td>
                  {additional.length > 0 && <td style={table.tdEmpty} />}
                  <td colSpan={extra_colspan}></td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div style={empty.wrap}>
            <div style={empty.icon}>📋</div>
            <div style={empty.title}>No Registrations Yet</div>
            <div style={empty.text}>Click "Add Registration" to get started.</div>
          </div>
        )}
      </div>
    );
  }
}

export default ViewCompetitionRegistration;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionRegistration/index.js